import { AvailableChildrenType, SugarElementInfo } from "../../Suggester/SugarElementInfo";

export const totalAmount: SugarElementInfo = {
    name: "totalAmount",
    availableChildren: { type: AvailableChildrenType.Any },
};
